export const Roles = {
    ADMIN: 1,
    REQUESTER: 2,
    VOLUNTEER: 3,


  };
  